import React, { useState, useEffect, useRef } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, orderBy, onSnapshot, addDoc, serverTimestamp, updateDoc, doc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { IoSend, IoArrowBack } from 'react-icons/io5';
import moment from 'moment';

const MuroChatWindow = ({ chat, onBack }) => {
    const { currentUser } = useAuth();
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const messagesEndRef = useRef(null);

    useEffect(() => {
        if (!chat) return;

        const messagesRef = collection(db, 'muro_chats', chat.id, 'messages');
        const q = query(messagesRef, orderBy('timestamp', 'asc'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const msgs = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setMessages(msgs);
            scrollToBottom();
        });

        return () => unsubscribe();
    }, [chat]);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const handleSend = async (e) => {
        e.preventDefault();
        if (!newMessage.trim()) return;

        try {
            const text = newMessage.trim();
            setNewMessage('');

            // 1. Add message to subcollection
            await addDoc(collection(db, 'muro_chats', chat.id, 'messages'), {
                text,
                senderId: currentUser.uid,
                timestamp: serverTimestamp()
            });

            // 2. Update chat metadata (last message)
            await updateDoc(doc(db, 'muro_chats', chat.id), {
                lastMessage: text,
                lastMessageTime: serverTimestamp()
            });

        } catch (error) {
            console.error("Error sending message:", error);
            alert("Error al enviar mensaje");
        }
    };

    const otherName = chat.residentNames ? chat.residentNames[chat.participants.find(uid => uid !== currentUser.uid)] : "Usuario";

    return (
        <div className="chat-window-container" style={{ display: 'flex', flexDirection: 'column', height: '100%', background: 'white', borderRadius: 20, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
            {/* Header */}
            <div className="chat-header" style={{ padding: '16px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', gap: 10, background: '#f9fafb' }}>
                <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 5 }}>
                    <IoArrowBack size={20} />
                </button>
                <div style={{ fontWeight: 600 }}>{otherName}</div>
                <div style={{ fontSize: '0.85rem', color: '#6b7280', flex: 1, textAlign: 'right' }}>
                    {chat.postTitle}
                </div>
            </div>

            {/* Messages */}
            <div className="chat-messages" style={{ flex: 1, overflowY: 'auto', padding: '20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                {messages.map(msg => {
                    const isMe = msg.senderId === currentUser.uid;
                    return (
                        <div
                            key={msg.id}
                            style={{
                                alignSelf: isMe ? 'flex-end' : 'flex-start',
                                maxWidth: '70%',
                                background: isMe ? '#4f46e5' : '#f3f4f6',
                                color: isMe ? 'white' : '#1f2937',
                                padding: '10px 16px',
                                borderRadius: isMe ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                            }}
                        >
                            <div>{msg.text}</div>
                            <div style={{ fontSize: '0.7rem', opacity: 0.7, marginTop: 4, textAlign: 'right' }}>
                                {msg.timestamp ? moment(msg.timestamp.toDate()).format('LT') : '...'}
                            </div>
                        </div>
                    );
                })}
                <div ref={messagesEndRef} />
            </div>

            {/* Input */}
            <form onSubmit={handleSend} style={{ padding: '16px', borderTop: '1px solid #f3f4f6', display: 'flex', gap: 10 }}>
                <input
                    type="text"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Escribe un mensaje..."
                    style={{
                        flex: 1, padding: '12px', borderRadius: '24px', border: '1px solid #d1d5db',
                        outline: 'none', fontSize: '0.95rem'
                    }}
                />
                <button
                    type="submit"
                    disabled={!newMessage.trim()}
                    style={{
                        width: 44, height: 44, borderRadius: '50%', background: '#4f46e5', color: 'white',
                        border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        opacity: !newMessage.trim() ? 0.5 : 1
                    }}
                >
                    <IoSend size={18} />
                </button>
            </form>
        </div>
    );
};

export default MuroChatWindow;
